<template>
  <div :class="['ms-form', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-camera" aria-hidden="true" />Комната и ракурс</h3>
        <div class="ms-form-grid">
          <CustomSelect
            :options="presetsOptions"
            label="Пресет"
            :required="true"
            optionValueKey="preset_id"
            optionLabelKey="preset_and_city"
            :fullWidth="true"
            :value="this.formData.preset_id"
            @change="(value) => onChange('preset_id', value)"
          />
          <CustomSelect
            :options="roomsOptions"
            label="Комната"
            :required="true"
            optionValueKey="room_id"
            optionLabelKey="room_name"
            :fullWidth="true"
            :value="this.formData.room_id"
            @change="(value) => onChange('room_id', value)"
          />
          <CustomSelect
            :options="rakursOptions"
            label="Ракурс"
            optionValueKey="rakurs_id"
            optionLabelKey="rakurs_name"
            :fullWidth="true"
            :value="this.formData.rakurs_id"
            @change="(value) => onChange('rakurs_id', value)"
          />
          <CustomInput
            :value="this.formData.order_index"
            type="number"
            :controls="true"
            :showClearIcon="false"
            label="Индекс"
            @change_input="(value) => onChange('order_index', value)"
            :fullWidth="true"
          />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-image" aria-hidden="true" />Фотография</h3>
        <div class="ms-form-grid">
          <div class="ms-form-wide">
            <CustomUploader
              :value="formData.room_photo"
              :on-change="(value) => onChange('room_photo', value)"
              label="Фотография"
              :fullWidth="true"
            />
            <a
              download
              target="_blank"
              rel="noopener noreferrer"
              class="upd-images__download"
              v-if="!!this.formData.image_url"
              :href="`${this.getSystemUrl().FILE_URL_OFFICE}${formData.image_url}`"
              link
            >
              <q-icon name="fa-solid fa-download" />&nbsp;Скачать оригинал
            </a>
          </div>
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-layer-group" aria-hidden="true" />Материалы</h3>
        <div class="ms-form-grid">
          <CustomSelect
            :options="materialSetsOptions"
            label="Набор материалов"
            optionValueKey="material_set_id"
            optionLabelKey="material_set_name"
            :fullWidth="true"
            :value="this.formData.material_set_id"
            @change="(value) => onChange('material_set_id', value)"
          />
          <CustomSelect
            :options="workSetsOptions"
            label="Ворксет"
            optionValueKey="work_set_id"
            optionLabelKey="work_set_name"
            :fullWidth="true"
            :value="this.formData.work_set_id"
            @change="(value) => onChangeWorkSet('work_set_id', value)"
          />
          <CustomSelect
            :options="parentMaterialOptions"
            label="Материал (Родитель)"
            optionValueKey="material_id"
            optionLabelKey="material_name"
            :fullWidth="true"
            :value="this.formData.material_pid"
            @change="(value) => onChangeWorkSet('material_pid', value)"
          />
          <CustomSelect
            :options="parentMaterialSetsOptions"
            label="Набор материала (Родитель)"
            optionValueKey="material_set_id"
            optionLabelKey="set_name"
            :fullWidth="true"
            :value="this.formData.material_set_pid"
            @change="(value) => onChange('material_set_pid', value)"
          />
        </div>
      </section>

      <CustomModalFooter :btn-loading="this.btnLoading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import CustomInput from "@/components/form/CustomInput";
import CustomUploader from "@/components/form/CustomUploader";
import {
  getRoomPictures,
  getPresetsOptions,
  getRoomsOptions,
  getRakursOptions,
  getMaterialSets,
  getWorkSetsForPic,
  getParentMaterial,
  getParentMaterialSets,
} from "@/views/Materials/MaterialsList/MaterialEdit/services";
import { getSystemUrl } from "@/services";

export default {
  name: "materials-constructor-upd-images",
  components: { CustomModalFooter, CustomSelect, CustomInput, CustomUploader },
  props: ["data"],
  data() {
    return {
      loading: false,
      btnLoading: false,
      material_id: this.data?.body.material_id || "",
      formData: {
        room_picture_id: this.data?.body.room_picture_id || "",
        material_id: this.data?.body.material_id || "",
        material_set_id: this.data?.body.material_set_id || "",
        order_index: this.data?.body.order_index || 100,
        room_photo: this.data?.body.room_photo || "",
        image_url: this.data?.body.image_url || "",
        preset_id: this.data?.body.preset_id || "",
        room_id: this.data?.body.room_id || "",
        rakurs_id: this.data?.body.rakurs_id || "",
        work_set_id: this.data?.body.work_set_id || "",
        material_pid: this.data?.body.material_pid || "",
        material_set_pid: this.data?.body.material_set_pid || "",
      },
      presetsOptions: [],
      roomsOptions: [],
      rakursOptions: [],
      materialSetsOptions: [],
      workSetsOptions: [],
      parentMaterialOptions: [],
      parentMaterialSetsOptions: [],
    };
  },
  watch: {
    "formData.preset_id"(newValue) {
      if (newValue && this.formData.room_id) {
        this.fetchWorkSets();
      }
    },
    "formData.room_id"(newValue) {
      if (newValue && this.formData.preset_id) {
        this.fetchWorkSets();
      }
    }
  },
  methods: {
    getSystemUrl,
    onChange(key, value) {
      this.formData[key] = value;
      if (key === "preset_id" || key === "room_id") {
        this.rakursOptions = [];
        this.formData.rakurs_id = "";
        if (!!this.formData.preset_id && !!this.formData.room_id) {
          this.fetchRakurs();
        }
      }
    },
    onChangeWorkSet(key, value) {
      this.formData[key] = value;
      if (key === "work_set_id") {
        this.fetchParentMaterial();
        this.parentMaterialSetsOptions = [];
        this.formData.material_pid = "";
      }
      if (key === "material_pid") {
        this.fetchParentMaterialSets();
      }
    },
    async onSubmit() {
      this.btnLoading = true;
      await this.data?.onSubmit(this.formData);
      this.btnLoading = false;
    },
    async fetchRoomPictures() {
      if (!this.formData.room_picture_id) return;
      const res = await getRoomPictures(this.formData.room_picture_id);
      if (!res) return;
    },
    async fetchPresets() {
      this.presetsOptions = await getPresetsOptions();
    },
    async fetchRooms() {
      this.roomsOptions = await getRoomsOptions();
    },
    async fetchRakurs() {
      if (!this.formData.preset_id || !this.formData.room_id) return;
      const body = {
        preset_id: this.formData.preset_id,
        room_id: this.formData.room_id,
      };
      this.rakursOptions = await getRakursOptions(body);
      if (this.rakursOptions?.length) {
        this.formData.rakurs_id = this.rakursOptions[0].rakurs_id;
      }
    },
    async fetchMaterialSets() {
      if (!this.material_id) return;
      this.materialSetsOptions = await getMaterialSets(this.material_id);
    },
    async fetchWorkSets() {
      const params = {
        preset_id: this.formData.preset_id,
        room_id: this.formData.room_id,
      }
      this.workSetsOptions = await getWorkSetsForPic(params);
    },
    async fetchParentMaterial() {
      if (!this.material_id) return;
      const body = {
        room_picture_id: this.formData.room_picture_id,
        work_set_id: this.formData.work_set_id,
      };
      this.parentMaterialOptions = await getParentMaterial(body);
    },
    async fetchParentMaterialSets() {
      if (!this.material_id) return;
      const body = {
        room_picture_id: this.formData.room_picture_id,
        work_set_id: this.formData.work_set_id,
        material_pid: this.formData.material_pid,
      };
      this.parentMaterialSetsOptions = await getParentMaterialSets(body);
    },
  },
  mounted() {
    this.fetchRoomPictures();
    this.fetchPresets();
    this.fetchRooms();
    this.fetchRakurs();
    this.fetchMaterialSets();
    this.fetchParentMaterial();
    this.fetchParentMaterialSets();
    if (this.formData.room_picture_id) {
      this.fetchWorkSets();
    }
  },
  computed: {
    computedLabel() {
      return (option) => `${option.material_set_id} / ${option.set_name}`;
    },
  },
};
</script>

<style scoped lang="scss">
// Блоки, сетка и ширина — общие (ms-form-* в theme.scss)
.upd-images__download {
  display: inline-flex;
  align-items: center;
  margin-top: 8px;
  font-size: 13px;
  color: var(--ms-primary);
}
</style>
